var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0.5 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.8166 19.316c0.093 0.54 0.561 0.9338 1.1085 0.9338h12.15c0.5475 0 1.0155-0.3938 1.1092-0.9338l1.3283-7.6912h-17.025l1.329 7.6912z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.334 3.3691c-0.26952-9.1e-6 -0.54084 0.10333-0.74414 0.30664l-5.3398 5.3398c-0.40598 0.40606-0.40605 1.0783 0 1.4844 0.40606 0.40606 1.0784 0.4062 1.4844 0l5.3242-5.3242 0.015625-0.017578c0.40625-0.4056 0.40625-1.0768 0-1.4824-0.20289-0.2033-0.47071-0.30663-0.74024-0.30664z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.798 8.625h-7.7978c-0.62175 0-1.125 0.50325-1.125 1.125 0 0.6217 0.50325 1.125 1.125 1.125h7.785c-0.5872-0.6352-0.5835-1.62 0.0128-2.25z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21 8.625h-5.5417l-2.25 2.25h7.7917c0.6218 0 1.125-0.5033 1.125-1.125 0-0.62175-0.5032-1.125-1.125-1.125z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product_icon.6c0c2e126ed506ad31ba490c41bec899.svg";
export { ForwardRef as ReactComponent };